import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { GoalsPage } from './GoalsPage'

export const routes: RouteObject[] = [{ path: '/teloscope/goals', element: <GoalsPage /> }]

// Вкладка раздела «Телоскоп» (pages/teloscope): заголовок раздела рисует оболочка.
export const nav: NavItem[] = [
  { path: '/teloscope/goals', label: 'Цели', icon: 'target', mobile: null, order: 20, parent: '/teloscope' },
]
